import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from '../../../../icons/icons.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorModule } from 'src/app/components/error/error.module';
import { UpdateRunbookVersionComponent } from './update-runbook-version.component';
@NgModule({
    declarations: [UpdateRunbookVersionComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslocoModule,
        MatDividerModule,
        FormsModule,
        IconsModule,
        MatTooltipModule,
        ErrorModule
    ]
})
export class UpdateRunbookVersionModule { }
